module.exports = __webpack_public_path__ + "static/img/warehouse1.8cabb12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/warehouse1.png
// module id = b7M5
// module chunks = 1